import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  depotRoutesOptimisedSelector,
  driverEditModalOpenSelector,
  isDailyPlanSelector,
  optimiseResultsOpenSelector,
  volumeDataSelector,
} from "../../../reducers/matrixProfile/selectors";
import {
  updateDriverEdit,
  processDriverEdit,
  closeDriverEdit,
} from "../../../reducers/matrixProfile/thunkActions";
import { NONE } from "../../../consts/strings";
import { Modal } from "../Modal";
import { EditDriverModalActions } from "./EditDriverModalActions";
import { EditDriverModalContent } from "./EditDriverModalContent";
import { ConfirmDailyDriverSaveDilog } from "../../ConfirmDailyDriverSaveDilog";

export const EditDriverModal = () => {
  const dispatch = useDispatch();
  const isDailyPlan = useSelector(isDailyPlanSelector);
  const depotRoutesOptimised = useSelector(depotRoutesOptimisedSelector);
  const volumeData = useSelector(volumeDataSelector);
  const driverEditModalOpen = useSelector(driverEditModalOpenSelector);
  const optimiseResultsOpen = useSelector(optimiseResultsOpenSelector);
  const [isValid, setIsValid] = useState();
  const [hasChanged, setHasChanged] = useState();
  const [showConfirmModal, setShowConfirmModal] = useState();

  useEffect(() => {
    if (!driverEditModalOpen) return;
    setIsValid(true);
    setHasChanged(false);
  }, [driverEditModalOpen]);

  const onValidation = (hasErrors) => setIsValid(!hasErrors);

  const onSave = () => {
    if (!isDailyPlan || (volumeData && depotRoutesOptimised))
      dispatch(processDriverEdit());
    else setShowConfirmModal(true);
  };

  const onConfirm = () => {
    dispatch(processDriverEdit());
    setShowConfirmModal(false);
  };

  const onDecline = () => setShowConfirmModal(false);

  const onChange = ({ name, value }) => {
    setHasChanged(true);
    // Promise must be returned to prevent multiple updated running simultaneously
    return dispatch(
      updateDriverEdit({
        name: name,
        value: value === NONE ? null : value,
      })
    );
  };

  if (!driverEditModalOpen) return null;
  return (
    <Modal
      open={!optimiseResultsOpen}
      title={`DRIVER DETAILS`}
      minWidth={440}
      onClose={() => dispatch(closeDriverEdit())}
      content={
        <>
          <EditDriverModalContent
            onValidation={onValidation}
            onChange={onChange}
          />
          <ConfirmDailyDriverSaveDilog
            open={!!showConfirmModal}
            onDecline={onDecline}
            onConfirm={onConfirm}
          />
        </>
      }
      actions={
        <EditDriverModalActions
          disabled={!isValid || !hasChanged}
          onSave={onSave}
        />
      }
    />
  );
};
